import data from "./data.json";
import statesNames from "./statesNames.json";
import yearsOffset from "./yearsOffset.json";
import leapYears from "./leapYears.json";
import monthsDays from "./monthsDays.json";
import statesPopulation from "./statesPopulation.json";
import peopleByState from "./peopleByState.json";

const getData = () => {
  return data;
};

const getStatesPopulation = () => {
  return statesPopulation;
};

const getLocations = () => {
  const locations = [];

  for (let i = 0; i < data.length; i++) {
    const locationExists = locations.includes(data[i].state);

    if (!locationExists) {
      locations.push(data[i].state);
    }
  }

  locations.sort();

  return locations;
};

const getStatesNames = () => {
  return statesNames;
};

const getYearsOffset = () => {
  return yearsOffset;
};

const getLeapYears = () => {
  return leapYears;
};

const getMonthsDays = () => {
  return monthsDays;
};

const getYears = () => {
  const years = [];

  for (let i = 0; i < data.length; i++) {
    const raceExists = years.includes(new Date(data[i].date).getFullYear());

    if (!raceExists) {
      years.push(new Date(data[i].date).getFullYear());
    }
  }

  years.sort((a, b) => b - a);

  return years;
};

const getRaces = () => {
  const races = [];

  for (let i = 0; i < data.length; i++) {
    const raceExists = races.includes(data[i].race);
    const isValidRace = data[i].race !== "" && data[i].race !== "Unknown race";

    if (!raceExists && isValidRace) {
      races.push(data[i].race);
    }
  }

  return races;
};

const getPeopleByRace = () => {
  const races = getRaces();

  const peopleByRace = races.map((race) => {
    return {
      race,
      data: data.filter((d) => d.race === race),
    };
  });

  return peopleByRace;
};

const getCensus = (location) => {
  let total = 331449281;

  return {
    total,
    percents: {
      Black: 0.136,
      White: 0.758,
      Hispanic: 0.189,
      Asian: 0.061,
      "Native American": 0.013,
      "Native Hawaiian and Pacific Islander": 0.003,
    },
  };
};

const getCensusByRace = (location) => {
  return peopleByState;
};

export {
  getData,
  getLocations,
  getYears,
  getRaces,
  getPeopleByRace,
  getCensus,
  getStatesNames,
  getYearsOffset,
  getLeapYears,
  getMonthsDays,
  getStatesPopulation,
  getCensusByRace
};
